// Iter 475 (Kamel) — 📱 WhatsApp perso : ouvre WhatsApp vers le numéro de la fiche avec un message
// contenant le LIEN PERSONNEL vers l'espace adhérent. À réutiliser partout où l'on relance une fiche.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function whatsappPerso(getAuthConfig, regId, buildMessage) {
  try {
    const r = await axios.get(`${API}/admin/espace-lien/${regId}`, getAuthConfig());
    if (!r.data.telephone) { alert('Pas de numéro de téléphone sur cette fiche.'); return; }
    if (!r.data.lien) { alert("Pas d'e-mail sur cette fiche : impossible de générer le lien personnel."); return; }
    const msg = buildMessage(r.data);
    window.open(`https://wa.me/${r.data.telephone}?text=${encodeURIComponent(msg)}`, '_blank', 'noopener');
  } catch (e) { alert(e.response?.data?.detail || 'Impossible de générer le lien personnel.'); }
}

export const msgFormalite = (label, limite) => ({ prenom, lien }) =>
  `Bonjour ${prenom || ''} 😊 C'est Rhône Alpes Amitié Voyages. Merci de compléter « ${label} » dans votre espace adhérent${limite ? ` avant le ${limite}` : ''}. Voici votre lien personnel (ne pas le partager) : ${lien}`;

export const msgSondage = (question) => ({ prenom, lien }) =>
  `Bonjour ${prenom || ''} 😊 C'est Rhône Alpes Amitié Voyages. Nous n'avons pas encore votre avis sur « ${question} ». Cela prend 10 secondes depuis votre espace adhérent (lien personnel, ne pas partager) : ${lien}`;

export const msgEspace = () => ({ prenom, lien }) =>
  `Bonjour ${prenom || ''} 😊 C'est Rhône Alpes Amitié Voyages. Une information importante vous attend dans votre espace adhérent. Voici votre lien personnel (ne pas le partager) : ${lien}`;
